export default __webpack_public_path__ + "static/media/warning.995f0cfd.svg";